import React from 'react';
import PropTypes from 'prop-types';
import {
  getWeekDaysBetween,
  serializeYesplanAPIDate,
  todayDateObject,
  YPDateTimeObjectPropType
} from '../../libs/dateTimeUtilities';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import TimesheetWeekDay from '../TimesheetWeekDay/TimesheetWeekDay';
import {
  EndOfRosterText,
  EndOfRosterTitle
} from '../../roster/RosterWeekView/RosterWeekView.style';
import LoadingState from '../../styled components/LoadingState';
import UICard from '../../styled components/UICard';
import TimesheetsEndOfPublishedPeriodSVG from './TimesheetsEndOfPublishedPeriodSVG';

export default class TimesheetsWeekView extends React.Component {
  constructor(props) {
    super(props);
    this.renderTimesheetDays = this.renderTimesheetDays.bind(this);
  }

  getDaysToRender() {
    const { week } = this.props;
    let lastDayToRender = week.endDateObject;
    if (week.startDateObject.isAfter(todayDateObject())) return [];
    if (week.endDateObject.isAfter(todayDateObject()))
      lastDayToRender = todayDateObject();

    return getWeekDaysBetween(week.startDateObject, lastDayToRender);
  }

  renderEndOfDaysToShow(completeWeekFlag) {
    const html = (
      <div tw="text-center">
        <p tw="mb-0 flex justify-center">
          <TimesheetsEndOfPublishedPeriodSVG />
        </p>
        <EndOfRosterTitle>
          {`“${i18n('The future depends on what you do today.')}”`}
          <br />— Mahatma Gandhi
        </EndOfRosterTitle>
        <EndOfRosterText>
          {i18n('You can’t fill in timesheets for days in the future.')}
        </EndOfRosterText>
      </div>
    );
    if (completeWeekFlag) return html;
    if (!completeWeekFlag) return html;
    return null;
  }

  renderWeekCounters() {
    return null;
    // const { timesheets } = this.props;
    // if (Object.keys(timesheets).length === 0) return null;
    // const weekCounters = Object.values(timesheets)[0].getWeekCounter();
    // const overworkCounters = Object.values(timesheets)[0].getOverworkCounter();
    // const worktimeIncludingOvertime = weekCounters.planned; // TODO: not correct, needs something like weekworkedincludingoverworkbonus
    // const overworkBonus = weekCounters.overtime || ''; // wrong
    // const totalOverworkIncludingBonus = overworkCounters.week;
    // return null;
    // if (this.getDaysToRender().length === 0) return null;
    //
    // return (
    //   <TimesheetCounters
    //     label="Week counters"
    //     totalWorkedTimeIncludingOvertime={worktimeIncludingOvertime}
    //     overworkBonus={overworkBonus}
    //     totalOverworkIncludingBonus={totalOverworkIncludingBonus}
    //   />
    // );
  }

  renderTimesheetDays() {
    const { timesheets } = this.props;
    const daysToRender = this.getDaysToRender();
    return (
      <>
        {daysToRender.map((dateObj) => {
          const dateString = serializeYesplanAPIDate(dateObj);
          const timesheetObject = timesheets[dateString];
          return (
            /* Wrap each Card in its own error boundary,
              such that other cards are rendered in case one of them errored.
              The boundary must have a unique key on each rendering, otherwise the errorboundary is not reset */
            <ErrorBoundary {...this.props} key={dateString}>
              <TimesheetWeekDay
                dayDateObject={dateObj}
                timesheetObject={timesheetObject}
                {...this.props}
              />
            </ErrorBoundary>
          );
        })}
        {daysToRender.length < 7 && this.renderEndOfDaysToShow(daysToRender.length === 0)}
      </>
    );
  }

  renderContent() {
    return (
      <>
        {this.renderWeekCounters()}
        <div tw="space-y-8">{this.renderTimesheetDays()}</div>
      </>
    );
  }

  renderLoadingState() {
    return (
      <div tw="relative">
        <div tw="z-100">
          <UICard $padding={24}>
            <LoadingState $show $size="small" />
          </UICard>
        </div>
      </div>
    );
  }

  render() {
    const { allContentFetched } = this.props;
    return !allContentFetched ? this.renderLoadingState() : this.renderContent();
  }
}

TimesheetsWeekView.propTypes = {
  week: PropTypes.shape({
    startDateObject: YPDateTimeObjectPropType,
    endDateObject: YPDateTimeObjectPropType
  }).isRequired,
  allContentFetched: PropTypes.bool.isRequired,
  timesheets: PropTypes.shape({}).isRequired
};

TimesheetsWeekView.defaultProps = {};
